import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';

const CreateFromTemplateModal = ({ show, onHide, onEventCreated }) => {
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [name, setName] = useState('');
    const [date, setDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (show) {
            setLoading(true);
            apiClient.get('/events/templates')
                .then(response => {
                    setTemplates(response.data);
                })
                .catch(err => {
                    setError('Не удалось загрузить шаблоны.');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [show]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!selectedTemplate || !name || !date) {
            setError('Пожалуйста, заполните все поля.');
            return;
        }

        try {
            const response = await apiClient.post(`/events/from-template/${selectedTemplate}`, {
                name,
                date: new Date(date).toISOString(),
            });
            toast.success('Событие успешно создано из шаблона!');
            onEventCreated(response.data.id);
            onHide();
        } catch (err) {
            setError(err.response?.data?.detail || 'Ошибка при создании события.');
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Создать событие из шаблона</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <p>Загрузка шаблонов...</p>
                ) : (
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Выберите шаблон</Form.Label>
                            <Form.Select 
                                value={selectedTemplate}
                                onChange={e => setSelectedTemplate(e.target.value)}
                                required
                            >
                                <option value="">-- Выберите шаблон --</option>
                                {templates.map(template => (
                                    <option key={template.id} value={template.id}>{template.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Название нового события</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={name} 
                                onChange={e => setName(e.target.value)} 
                                required 
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Дата и время нового события</Form.Label>
                            <Form.Control 
                                type="datetime-local" 
                                value={date} 
                                onChange={e => setDate(e.target.value)} 
                                required 
                            />
                        </Form.Group>
                        {error && <p className="text-danger">{error}</p>}
                    </Form>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Отмена</Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>Создать</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateFromTemplateModal;
